import { makeDeleteOperation } from '@occc-app/offerHelpers/operations/makeDeleteOperation';
import { Operation } from '@occc-app/offerHelpers/types';

type PresenceConstraint = { id: string } | undefined;

export const getPresenceConstraintOperations = (
  offerId: string,
  existingConstraint: PresenceConstraint,
  shouldBeEnabled: boolean,
  makeCreateOperation: (offerId: string) => Operation,
): Operation[] => {
  if (existingConstraint && !shouldBeEnabled) {
    return [makeDeleteOperation('constraintDelete', existingConstraint.id)];
  }

  if (!existingConstraint && shouldBeEnabled) {
    return [makeCreateOperation(offerId)];
  }

  return [];
};
